import React, { useEffect, useState } from 'react';
export function CountdownTimer() {
  const [time, setTime] = useState({
    hours: 1,
    minutes: 30,
    seconds: 49
  });
  useEffect(() => {
    const interval = setInterval(() => {
      setTime(prev => {
        let {
          hours,
          minutes,
          seconds
        } = prev;
        if (seconds > 0) seconds--;else if (minutes > 0) {
          minutes--;
          seconds = 59;
        } else if (hours > 0) {
          hours--;
          minutes = 59;
          seconds = 59;
        }
        return {
          hours,
          minutes,
          seconds
        };
      });
    }, 1000);
    return () => clearInterval(interval);
  }, []);
  const pad = (n: number) => String(n).padStart(2, '0');
  return <div className="grid grid-cols-3 gap-3 max-w-sm mx-auto" data-id="element-49">
      {[{
      label: 'Hours',
      value: pad(time.hours)
    }, {
      label: 'Minutes',
      value: pad(time.minutes)
    }, {
      label: 'Seconds',
      value: pad(time.seconds)
    }].map((unit, idx) => <div key={idx} className="bg-pilates-dark text-white rounded-xl py-3 px-2 text-center shadow-md" data-id="element-50">
          <div className="font-display text-3xl sm:text-4xl font-semibold text-pilates-cream leading-none" data-id="element-51">
            {unit.value}
          </div>
          <div className="text-[10px] sm:text-xs uppercase tracking-wider text-white/70 mt-1" data-id="element-52">
            {unit.label}
          </div>
        </div>)}
    </div>;
}